// Core
import React from 'react';
// Styles
import './App.css';
// Components
import Home from './pages/Home';

const App = props => {
    return <Home />;
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js